import api from "./api";

export const getCollectionRequestStatus = (query, options) =>
  api.get({
    path: "/collections/requeststatus",
    query,
    options,
  });
